// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2985":"fc35f964d6ff2a3d","3127":"a3168abc1a0eeca8","5702":"a418d53b41291765"}[chunkId] + ".css";
};